import MenuItem from "@mui/material/MenuItem";
import { AttendingEventType } from "store/attendingEvents/attendingEvents.types";
import styled from "styled-components";

export const EventCard = styled.div`
  display: flex;
  gap: 0.7rem;
  margin: 0.6rem 0;
  padding: 0.75rem;
  //border-radius: 0.75rem;
  background: #FFFFFF;
  //border: 0.0625rem solid #E5E7EB;
  transition: all 0.2s ease-in-out;
  cursor: pointer;
  
  &:hover {
    transform: translateY(-0.0625rem);
    box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.05);
    border-color: #D1D5DB;
  }
`;

export const DateLabel = styled.strong`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 3.75rem;
  height: 3.75rem;
  background: #F9FAFB;
  border-radius: 0.75rem;
  border: 0.0625rem solid #E5E7EB;
  padding: 0.5rem;
  transition: all 0.2s ease-in-out;
  
  &:hover {
    background: #F3F4F6;
  }
`;

export const EventInfo = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const EventTitle = styled.span`
  font-size: 0.9rem;
  font-weight: 600;
  color: #111827;
  line-height: 1.4;
  margin-bottom: 0.125rem;
  display: block;
`;

export const EventLocation = styled.span`
  font-size: 0.8rem;
  color: #6B7280;
  display: flex;
  align-items: center;
  gap: 0.25rem;
`;

export const Day = styled.span`
  font-weight: 700;
  font-size: 1.5rem;
  line-height: 1;
  color: #111827;
  margin-bottom: 0.125rem;
`;

export const Month = styled.span`
  font-weight: 600;
  font-size: 0.75rem;
  letter-spacing: 0.75px;
  text-transform: uppercase;
  color: #6B7280;
`;

export const OptionButton = styled(MenuItem)<{ status: AttendingEventType.CONFIRMED | AttendingEventType.REFUSED}>`
  border-radius: 1rem;
  font-weight: 600;
  font-size: 0.9rem;
  margin: 0.25rem 0;
  padding: 0.375rem 1.125rem;
  color: ${({ status }) =>
    status === AttendingEventType.CONFIRMED ? "#047857" : "#B91C1C"};
  background: ${({ status }) =>
    status === AttendingEventType.CONFIRMED ? "#A7F3D0" : "#FCA5A5"};
  border: 0.0625rem solid
    ${({ status }) =>
      status === AttendingEventType.CONFIRMED
        ? "rgba(4, 120, 87, 0.1)"
        : "rgba(185, 28, 28, 0.1)"};
  transition: background 0.2s, color 0.2s;
  &:hover {
    background: ${({ status }) =>
      status === AttendingEventType.CONFIRMED ? "#6EE7B7" : "#F87171"};
    color: ${({ status }) =>
      status === AttendingEventType.CONFIRMED ? "#065F46" : "#991B1B"};
  }
`;

export const ActionButton = styled.button`
  align-self: center;
  margin-left: auto;
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  font-weight: 600;
  font-size: 0.875rem;
  color: #FE2F67;
  background: #FFF1F4;
  border: 0.0625rem solid #FFE4E9;
  transition: all 0.2s ease-in-out;
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    background: #FFE4E9;
    color: #E62A5D;
  }

  &:active {
    transform: translateY(0.0625rem);
  }
`;
